export default __webpack_public_path__ + "static/media/ExceptionHp.4b14ea8e.png";